import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import {Box, Stack} from "@mui/material";
import LocalStorageTimer from "@/components/LocalStorageTimer.tsx";
import {useCartContext} from "@/components/Providers/CartProvider.tsx";

const CartTimeoutBanner = () => {
    const {cart, emptyCart} = useCartContext();

    const timeout = cart?.cartTimeout;

    const cartTimeout = () => {
        emptyCart();
    };

    return cart?.cartItems.length && timeout ? (
        <Box sx={{px: 0, width: "100%"}}>
            <Stack
                sx={{
                    width: "100%",
                    p: 2,
                    backgroundColor: "yellow",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <AccessAlarmIcon />
                <Box sx={{pl: 2}}>
                    Please complete your checkout within the next{" "}
                    <LocalStorageTimer timeout={timeout} callback={cartTimeout} />
                    &nbsp;minutes to pay for your cart items or they will be canceled.
                </Box>
            </Stack>
        </Box>
    ) : (
        <></>
    );
};

export default CartTimeoutBanner;
